import { cloudFunction } from 'services/parse';
import _ from 'lodash';

export const fetchOrders = async (data: Record<string, any>) => {
  let response = await cloudFunction('fetchOrders', data);
  response = {
    ...response,
    items: response.items?.map(row => ({
      ...row,
      route: row.route?.toJSON() || null,
    })),
  };
  return response;
};

export const fetchOrderDetail = async (id: string) => {
  // Backend implementations have historically used different param names. Send both.
  let response = await cloudFunction('orderDetail', { id, orderId: id });
  if (response.route) {
    response = {
      ...response,
      route: response?.route.toJSON(),
    };
  }
  if (response.events) {
    response = {
      ...response,
      events: response?.events,
    };
  }
  if (response?.salesChannel) {
    response = {
      ...response,
      salesChannel: response?.salesChannel?.toJSON(),
    };
  }
  if (response?.account) {
    response = {
      ...response,
      account: response?.account?.toJSON(),
    };
  }
  if (response?.salesPerson) {
    response = {
      ...response,
      salesPerson: response?.salesPerson?.toJSON(),
    };
  }
  return response;
};

export const updateOperatorComment = async (id: string, comment: string) => {
  return cloudFunction('updateOperatorComment', { id, comment });
};

export const fetchOrdersWithoutRoute = async () => {
  return cloudFunction('fetchOrdersWithoutRoute', {});
};

export const fetchCurrentImmediateOrders = async () => {
  return cloudFunction('fetchCurrentImmediateOrders', {});
}; 

export const fetchPendingSpotCheckCount = async () => {
  return cloudFunction('fetchPendingSpotCheckCount', {});
};

export const fetchMustHaveItemsWithoutStock = async () => {
  const response = await  cloudFunction('fetchMustHaveItemsWithoutStock', {});
  return response?.map(item => item.toJSON());
};

export const fetchItemsWithoutInventoryAddress = async () => {
  const response = await cloudFunction('fetchItemsWithoutInventoryAddress', {});
  return response?.map(item => item.toJSON());
};

export const fetchInActiveItemsWithStock = async () => {
  const response = await cloudFunction('fetchInActiveItemsWithStock', {});
  return response?.map(item => item.toJSON());
};

export const markOrderAsDelivered = (id: string) => {
  return cloudFunction('markOrderAsDelivered', { id });
};

export const markOrderAsPacked = (id: string) => {
  return cloudFunction('markOrderAsPacked', { id });
};

export const markOrderAsUnpacked = (id: string) => {
  return cloudFunction('unpackOrder', { id });
};

export const refundDeliveryCharges = (id: string) => {
  return cloudFunction('refundDeliveryCharges', { id });
};

export const refundPartialOrder = (orderId: string, orderItemsForRefund: Record<string, any>[]) => {
  return cloudFunction('refundPartialOrder', { orderId, orderItemsForRefund });
};

export const cancelAndRefundOrder = (orderId: string, reason: string) => {
  return cloudFunction('cancelAndRefundOrder', { orderId, reason });
};

export const removeOrderFromRoute = (orderId: string) => {
  return cloudFunction('removeOrderFromRoute', { orderId });
};

export const addOrderToRoute = (routeId: string, orderId: string) => {
  return cloudFunction('addOrderToRoute', { routeId, orderId });
};

export const addOrdersToRoute = (routeId: string, orderIds: string[]) => {
  return cloudFunction('addOrdersToRoute', { routeId, orderIds });
};

export const getRefundReasons = () => {
  return cloudFunction('getRefundReasons', {});
};

export const requestCourier = (id: string, selectedDeliveryType: string) => {
  return cloudFunction('requestCourier', { id, selectedDeliveryType });
};

export const addOrderItem = (orderId: string, itemId: string, count: number) => {
  return cloudFunction('addOrderItem', { orderId, itemId, count });
};

export const updateOrderItem = (orderItemId: string, count: number) => {
  return cloudFunction('updateOrderItem', { orderItemId, count });
};

export const resendOrderEmail = (data: Record<string, any>) => {
  return cloudFunction('resendOrderEmail', data);
};

export const sendDeliveryEstimation = (id: string) => {
  return cloudFunction('sendOrderDeliveryTimeEmailToClient', { id });
};

export const updatePaymentProof = (id: string, paymentProof: string, paymentProofImage: any) => {
  return cloudFunction('updatePaymentProof', { id, paymentProof, paymentProofImage });
};

export const payForWaitingForPaymentOrder = (id: string, paymentMethodId: string) => {
  return cloudFunction('payForWaitingForPaymentOrder', { id, paymentMethodId });
};

export const updateBagsOnOrder = async (params: {
  id: string;
  bags: any;
}) => {
  return cloudFunction('updateBagsOnOrder', params);
};

export const setSalesPersonInOrder = async (params: {
  orderId: string;
  userId: string;
}) => {
  return cloudFunction('setSalesPersonInOrder', params);
};

export const exportSalesPersonReport = async (params: any) => {
  return cloudFunction('exportSalesPersonReport', params);
};